module.exports = __webpack_public_path__ + "img/skyhub-mobile-app.ec61f4e2.png";